// file
import apiService from "./PostgreApiService";

// PostgreSQL RPC Login
export const postgreLogin = (data) => apiService.post("/login", data);

// PostgreSQL RPC product list
export const getProductList = (data) => apiService.post("/getproductlist", data);

// PostgreSQL RPC common items list
export const getCommonItemsist = (data) => apiService.post("/get_common_items", data);

// PostgreSQL RPC promo list
export const getPromoProductList = (data) => apiService.post("/get_promo_product_list", data);

// PostgreSQL RPC made for you
export const madeForYouList = (data) => apiService.post("/madeforyoulist", data);
